import { JIKE_WEB_HOST, JIKE_WEB_MOBILE_HOST } from './request/host'

export function getSearchParams() {
	return new URL(window.location.href).searchParams
}
export function getSearchParam(key: string) {
	return getSearchParams().get(key)
}
export function isInternalLink(link: string) {
	try {
		const url = new URL(link)

		return [JIKE_WEB_MOBILE_HOST, JIKE_WEB_HOST].some((item) => item.includes(url.hostname))
	} catch (e) {
		return false
	}
}
